<template>
  <section class="about" id="_">

    <div class="container">
      
      <h2 class="_title" :style="{marginTop:'0'}">Where am I coming from?</h2>

      <div class="content">

        <p>
          First of all, my name is <b>Félix Natanael Abad</b>, I'm a graduated Systems and Computing Engineer, <b>I've been programming 
          since 2013</b> but it was until 2020 that I became a <b>Software Developer</b>. I know that's a long time and my abilities may not 
          represent that long time, it is because I didn't have the right focus on this. After being in the process of becoming an 
          IT professional, I understood what is programming about and now I'm feeling things changing.
        </p>


        <p>
          My career in the computing field started in 2012 when I was in high school, I started to see computers not only as entertainment stuff. 
          In those moments I met my first programming language Object Pascal (in Delphi 7), later I met Visual Basic 6.0 and Visual Basic .NET 
          (which I was learning for 5+ years). I also learned a little about Web development, by that moment the trendy tools were Adobe Dreamweaver, 
          Abode Fireworks, Adobe Photoshop, Adobe Flash and MS Frontpage (at least those a met).
        </p>

        <p>
          Now that I am on the other side, I feel the will of taking part in important projects, I feel the desire for growth and leave a little 
          piece of me everywhere I do my job.
        </p>

        <h2>As developer...</h2>

        <p>
          I like to keep things easy and ordered (the most to my possibilities). I love minimalist design and use it as my design pattern 
          (note that I'm not a designer). I know that learning a lot of things doesn't make you better, what really matters is how deep you go 
          into one single thing and how much you master the ability.
        </p>

        <p>
          Since I got that anybody can write code, I prefer taking paper and pen for creating ideas, and yes, I know that creating the wheel again 
          isn't a good idea but I also know that your ideas are what makes you different, for that I don't mind when doing the things my way but 
          all the time open minded to fix failures or going back to the rules... Yes, it may sound like a wrong idea, but I'm not doing like that 
          all the time, when it comes to something demanding I take the secure lane and make things work right, instead of doing what I think.
        </p>
      </div>

      <h2 class="_title" v-if="targetFetchErr || targetLoading || targets.length">Where am I headed?</h2>
      
      <div class="content targets" v-if="(!targetFetchErr && !targetLoading) && targets.length">

        <div class="target" v-for="(target, i) in targets" :key="i">
          <div class="icon">
            <img :src="target.icon" alt="icon">
          </div>
          <div class="tContent">
            <p class="title">{{target.title}}</p>
            
            <p class="text" v-for="(par, i) in target.content" :key="i">
                {{par}}
            </p>
          </div>
        </div>

      </div>

      <div class="spinerParent" v-if="targetLoading">
        <img src="../assets/spinb.png" />
      </div>

      <fetchError :style="{display:targetFetchErr?'flex':'none', margin: '25px 0 50px 0'}" :Exception="targetFetchErr" />

      <h2 class="_title">I'm not only a software developer...</h2>
      
      <div v-for="(about, i) in sections" :class="{ content: true, dynamic: (Math.floor(i%2)==0), dynamicRev: (Math.floor(i%2)!=0)}" :key="i">
        
        <div class="secTitle">
          <h2>{{about.title}}</h2>
        </div>

        <div class="text">
          <p v-for="(par, i) in about.section" :key="i">{{par}}</p>
        </div>

        <div class="slider">
          <carousel-3d 
            :autoplay="true" 
            :autoplayTimeout="5000" 
            :display="1" 
            :count="about.images.length"
            :width="500"
            :height="345"
            :loop="true"
            :animationSpeed="500"
          >
            <slide v-for="(image, i) in about.images" v-bind:index="i" v-bind:key="i">
              <template>
                <img :src="image" :style="{objectFit: 'scale-down', height: '100%', width: '100%'}" />
              </template>
            </slide>
          </carousel-3d>
        </div>

      </div>

      <div class="spinerParent" v-if="loading">
        <img src="../assets/spinb.png" />
      </div>

      <fetchError :style="{display:fetchErr?'flex':'none', margin: '25px 0 50px 0'}" :Exception="fetchErr" />

      <lastEvent />
    </div>
    
  </section>
</template>

<script>
import lastEvent from "@/components/Small/lastAchievement.vue";
import fetchError from "./Small/fetchError.vue";
import { Carousel3d, Slide } from 'vue-carousel-3d';

import Request from "../mixins/axiosRequest.js";

export default {
  name: "About",
  components: {
    lastEvent,
    fetchError,
    Carousel3d,
    Slide,
  },

  data() {
    return {
      sections: [],
      targets: [],
      loading: true,
      targetLoading: true,
      fetchErr: null,
      targetFetchErr: null
    };
  },

  methods: {
    async getSections() {
      let data = await Request.axiosGet("/api/about", this.client);
      if(data.status) {
        this.sections = data.data;
      } else {
        this.fetchErr = data.data;
      }
      this.loading = false;
    },
    async getTargets() {
      let data = await Request.axiosGet("/api/target", this.client);
      if(data.status) {
        this.targets = data.data;
      } else {
        this.targetFetchErr = data.data;
      }
      this.targetLoading = false;
    }
  },

  mounted() {
    this.getSections();
    this.getTargets();
    this.loading = true;
    this.targetLoading = true;
  }
};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  .content {
    background-color: #00000044;
  }

}

@media (prefers-color-scheme: light) {
  .content {
    background-color: #ffffff44;
  }
}

.about {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1366px;
  margin: 0 auto 0 auto;
  padding-bottom: 2em;
}

h2 {
  color: #000;
}

._title {
  font-size: 2em;
  letter-spacing: 3px;
  color: #000;
  cursor: default;
  margin: 0 0;
  margin: 50px 0 15px 0;
}

.content {
  width: 80%;
  height: auto;
  padding: 25px 30px;
  height: auto;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;

                           /* From https://css.glass */
  box-shadow: 0px 0px 5px #000000ab;
  -webkit-backdrop-filter: blur(6.2px);
  backdrop-filter: blur(6.2px);
  transition: background-color .4s;
}

.content p,
b {
  text-align: justify;
  margin: 15px 0;
  color: #000;
  font-size: 18px;
}

.content p {
  line-height: 27px;
  font-weight: 500;
}

.content p b {
  font-weight: bolder;
}

.dynamic {
  height: auto;
  position: relative;

  display: grid;
  grid-template-rows: 3;
  grid-template-columns: 2;
  grid-template-areas: 'tit tit'
                       'ga1 ga2'
                       'ga1 ga2';
  margin-bottom: 40px;                
  .slider {
    display: flex;
    justify-content: center;
    align-items: center;
    
    grid-area: ga2;
    margin: 10px 10px;
    height: auto;
    width: auto;
    min-height: 345px;
    min-width: 550px;
  }
  .text {
    grid-area: ga1;
    margin: 10px 10px;
  }

  .secTitle {
    width: 100%;
    grid-area: tit;
    padding: 5px 0 15px 0;
  }

  .carousel-3d-slide {
    background-color: transparent;
    cursor: default;
    border: none;
  }
}

.dynamicRev {
  height: auto;
  position: relative;

  display: grid;
  grid-template-rows: 3;
  grid-template-columns: 2;
  grid-template-areas: 'tit tit'
                       'ga2 ga1'
                       'ga2 ga1';

  margin-bottom: 40px;
                       
  .slider {
    display: flex;
    justify-content: center;
    align-items: center;
    
    grid-area: ga2;
    margin: 10px 10px;
    height: auto;
    width: auto;
    min-height: 345px;
    min-width: 550px;
  }
  .text {
    grid-area: ga1;
    margin: 10px 10px;
  }

  .secTitle {
    width: 100%;
    grid-area: tit;
    padding: 5px 0 15px 0;
  }

  .carousel-3d-slide {
    background-color: transparent;
    cursor: default;
    border: none;
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1366px;
  margin: 0px auto 0px auto;
  padding: 35px 0 0 0;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;

  .targets {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px 50px 0 50px;
    .target {
      padding: 15px 15px 15px 5px;
      margin: 15px 25px;
      border-left: 5px solid black;
      background-color: #00000035;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
      max-width: 470px;
      display: flex;
      .icon {
        display: flex;
        min-width: 120px;
        margin: 0 10px 0 0;
        img {
          width: 100px;
          height: 100px;
          margin: auto;
        }
      }

      .tContent {
        .title {
          font-weight: bold;
          font-size: 20px;
          margin-top: 0;
        }
        .text {
          text-align: justify;
          line-height: 20px;
          font-size: initial;
        }
      }

    }
  }
}

@media screen and (max-width: 900px) {

  .dynamic {
    grid-template-areas: 'tit tit'
                         'ga1 ga1'
                         'ga2 ga2';
    .slider {
      grid-area: ga2;
      min-width: 320px;
    }
    .text {
      grid-area: ga1;
    }
    .secTitle {
      grid-area: tit;
    }
  }

  .dynamicRev {
    display: grid;
    grid-template-rows: 3;
    grid-template-areas: 'tit tit'
                          'ga2 ga2'
                          'ga1 ga1';
    .slider {
      grid-area: ga2;
      min-width: 320px;
    }
    .text {
      grid-area: ga1;
    }
    .secTitle {
      grid-area: tit;
    }
  }
}

@media screen and (max-width: 780px) {
  .about {
    height: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 575px) {
  .container {
    .targets {
      .target {
        padding: 15px;
        margin: 15px 5px;
        flex-direction: column;
        .icon {
          margin: 0;
        }

        .tContent {
          .title {
            text-align: center;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .about {
    height: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content {
    width: 95%;
    height: auto;
    padding: 10px 5px;
    margin: 10px 0;
    height: auto;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;

    p {
      font-size: 15px;
    }
  }

  .container {
    .targets {
      margin: 0px 0px 0 0px;
    }
  }
}

</style>
